import React, { useState } from 'react'
import { Box, Typography, Card, CardContent, Avatar, Chip, TablePagination, CircularProgress, Paper, IconButton, FormControl, InputLabel, Select, MenuItem, ToggleButton, ToggleButtonGroup, Tooltip, Alert } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ViewListIcon from '@mui/icons-material/ViewList'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import DialpadIcon from '@mui/icons-material/Dialpad';
import ListIcon from '@mui/icons-material/List'
import GroupIcon from '@mui/icons-material/Group';
import PhoneIcon from '@mui/icons-material/Phone';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import CallEndIcon from '@mui/icons-material/CallEnd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { short, sip, shortFunctionList, input, menu, global, ivrSingle, group, ivr } from "../../translate";
import Utils from "../../Utils";
import Cookies from "js-cookie";
import Api from "../../Api";
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import EmailIcon from '@mui/icons-material/Email';
import { toast } from 'react-toastify';
import { activitiesStyles, employeeTableStyles } from "../../helpers/style";
import AssignedSearch from "./AssignedSearch";
import { useSelector } from 'react-redux';
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

export default function IvrTable({
    data = [],
    setData = () => { },
    loading = false,
    title = '',
    viewMode = 'table',
    onViewModeChange = () => {}
}) {
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [searchQuery, setSearchQuery] = useState('')
    const navigate = useNavigate()
    const [sortBy, setSortBy] = useState(null)
    const [sortOrder, setSortOrder] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(Cookies.get("ivr") ? parseInt(Cookies.get("ivr")) : 10)
    const [copied, setCopied] = useState(false)
    const [tabFilter, setTabFilter] = useState('all') // 'all' | 'sending_mail'
    const employeeData = useSelector(state => state.users.employeeData)
    const onEdit = (id) => {
        navigate(`/ivr_single/${id}`)
    }
    const onDelete = async (id) => {
        if (window.confirm(ivr.delete_confirm[langIndex])) {
            try {
                const response = await Api.groupsDelete(id)
                if (response?.data?.status === 'ok') {
                    toast.success(global.deleted[langIndex])
                    setData(prev => prev.filter(g => g.id !== id))
                }
            } catch (error) {
                console.error('Error deleting IVR group:', error)
                toast.error(ivr.error_deleting[langIndex])
            }
        }
    }
    const onAdd = () => {
        navigate('/ivr_single/add')
    }
    const titleArr = [
        sip.note[langIndex],
        short.short[langIndex],
        short.list[langIndex],
        short.no_answer[langIndex],
    ]

    let descArr = []

    const handleSearchChange = (value) => {
        setSearchQuery(value)
    }

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
        } else {
            setSortBy(column)
            setSortOrder('asc')
        }
    }

    const handleTabFilterChange = (_, value) => {
        if (value != null) {
            setTabFilter(value)
            setPage(0)
        }
    }

    // Tab filter: all = all, sending_mail = has send_mail
    const tabFilteredData = tabFilter === 'sending_mail'
        ? data.filter(item => item.send_mail && String(item.send_mail).trim())
        : data

    // Filter data based on search query
    const filteredData = searchQuery
        ? tabFilteredData.filter(item => {
            const query = searchQuery.toLowerCase()
            const searchableFields = [
                item.name,
                item.id,
                item.virtual,
                item.noaction,
                item.item_count
            ]
            return searchableFields.some(field =>
                field !== null &&
                field !== undefined &&
                String(field).toLowerCase().includes(query)
            )
        })
        : tabFilteredData

    // Sort filtered data
    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortBy) return 0

        let aValue, bValue

        switch (sortBy) {
            case 'name':
                aValue = a.name || ''
                bValue = b.name || ''
                break
            case 'virtual':
                aValue = a.virtual || ''
                bValue = b.virtual || ''
                break
            case 'list':
                aValue = a.item?.length || a.item_count || 0
                bValue = b.item?.length || b.item_count || 0
                break
            case 'noaction':
                aValue = a.noaction || ''
                bValue = b.noaction || ''
                break
            default:
                return 0
        }

        if (sortOrder === 'asc') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
    })

    // Prepare data for export
    descArr = sortedData.map(s => ({
        notes: s?.name || '',
        virtual: s.virtual || '',
        list: s?.item?.length || s?.item_count || 0,
        noAnswer: s.noaction || ''
    }))

    // Paginate data
    const paginatedData = rowsPerPage > 0
        ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : sortedData

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10)
        setRowsPerPage(newRowsPerPage)
        setPage(0)
        Cookies.set("ivr", newRowsPerPage, { expires: 30 })
    }

    return (
        <div className="tableParent" id="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
                <Box sx={employeeTableStyles.headerBox}>
                    <Box sx={employeeTableStyles.headerTitleBox}>
                        <Typography sx={employeeTableStyles.title} variant="h5" component="h1">{title || menu.ivr[langIndex]}</Typography>
                    </Box>
                    {/* <ToggleButtonGroup
                        value={viewMode}
                        exclusive
                        onChange={onViewModeChange}
                        aria-label="view mode"
                        size="small"
                    >
                        <ToggleButton value="table" aria-label="table view">
                            <ViewListIcon />
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="card view">
                            <ViewModuleIcon />
                        </ToggleButton>
                    </ToggleButtonGroup> */}
                </Box>
                <Box sx={employeeTableStyles.searchSortContainer}>
                    <Box sx={employeeTableStyles.searchBox}>
                        <AssignedSearch
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onAdd={onAdd}
                            placeholder={input.search?.[langIndex]}
                            showAdd={true}
                            addColor={color}
                        />
                    </Box>
                    <Box sx={employeeTableStyles.sortContainer}>
                        <FormControl size="small" sx={employeeTableStyles.sortFormControl}>
                            <InputLabel>{input.sortBy[langIndex]}</InputLabel>
                            <Select
                                value={sortBy || ''}
                                label={input.sortBy[langIndex]}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        handleSort(e.target.value)
                                    } else {
                                        setSortBy(null)
                                        setSortOrder(null)
                                    }
                                }}
                                sx={employeeTableStyles.sortSelect}
                            >
                                <MenuItem value="">
                                    <em>{input.none[langIndex]}</em>
                                </MenuItem>
                                <MenuItem value="name">{input.name[langIndex]}</MenuItem>
                                <MenuItem value="virtual">{short.group[langIndex]}</MenuItem>
                                <MenuItem value="list">{short.list[langIndex]}</MenuItem>
                                <MenuItem value="noaction">{ivrSingle.no_answer_list[langIndex]}</MenuItem>
                            </Select>
                        </FormControl>
                        {sortBy && (
                            <IconButton
                                size="small"
                                onClick={() => handleSort(sortBy)}
                                sx={employeeTableStyles.getSortIconButton(color)}
                                aria-label={sortOrder === 'asc' ? input.sortDesc[langIndex] : input.sortAsc[langIndex]}
                            >
                                {sortOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                            </IconButton>
                        )}
                    </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <ToggleButtonGroup
                        value={tabFilter}
                        exclusive
                        onChange={handleTabFilterChange}
                        size="medium"
                        sx={{
                            '& .MuiToggleButton-root': { textTransform: 'none', py: 1, px: 2, fontSize: '0.95rem' },
                            '& .MuiToggleButton-root.Mui-selected': { backgroundColor: color, color: '#fff', '&:hover': { backgroundColor: color } },
                        }}
                    >
                        <ToggleButton value="all" aria-label={ivr.all[langIndex]}>
                            {ivr.all[langIndex]}
                        </ToggleButton>
                        <ToggleButton value="sending_mail" aria-label={ivr.sending_mails[langIndex]}>
                            <EmailIcon sx={{ fontSize: 22, mr: 0.75 }} />
                            {ivr.sending_mails[langIndex]}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {tabFilter === 'sending_mail' && (
                    <Alert
                    icon={<EmailIcon />}
                    severity="success"
                    sx={
                        REACT_APP_SERVER !== 'ATS'
                            ? { mb: 3, }
                            : {
                                mb: 3,
                                border: `1px solid ${color}`,
                                backgroundColor: `${color}10`,
                                '& .MuiAlert-icon': { color },
                            }
                    }
                >
                        <Typography variant="body2">
                            {ivr.sending_mails_info[langIndex]}
                        </Typography>
                    </Alert>
                )}

                {loading ? (
                    <Box sx={employeeTableStyles.loadingBox}>
                        <CircularProgress sx={{ color }} />
                    </Box>
                ) : paginatedData.length ? (
                    <>
                        <Box sx={activitiesStyles.activitiesContainer}>
                            {paginatedData.map((s) => {
                                const displayName = s?.name || (s?.item?.length ? s?.item[0]?.member_buddy?.[0]?.notes : '') || ''
                                const isWaiting = s?.cwaiting
                                
                                return (
                                    <Card key={s.id} sx={{ ...activitiesStyles.activityCard, '&:hover': { boxShadow: `0 8px 24px ${color}26`, borderColor: color } }}>
                                        <CardContent sx={activitiesStyles.cardContent}>
                                            <Box sx={activitiesStyles.cardContentBox}>
                                                <Avatar sx={{
                                                ...activitiesStyles.getActivityAvatar(isWaiting),
                                                ...(isWaiting && { bgcolor: color, boxShadow: `0 4px 12px ${color}4D` }),
                                            }}>
                                                    {displayName?.[0]?.toUpperCase() || 'I'}
                                                </Avatar>

                                                <Box sx={activitiesStyles.activityContentBox}>
                                                    {isWaiting ? (
                                                        <Box sx={activitiesStyles.chipsContainer}>
                                                            <Chip
                                                                label={ivr.waiting[langIndex]}
                                                                size="small"
                                                                sx={activitiesStyles.methodChip}
                                                            />
                                                        </Box>
                                                    ) : null}

                                                    <Typography variant="h6" sx={activitiesStyles.activityTitle}>
                                                        {displayName}
                                                    </Typography>

                                                    <Box sx={activitiesStyles.metadataBox}>
                                                        {s?.virtual ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <Box sx={activitiesStyles.iconSquareBox}>
                                                                    <GraphicEqIcon fontSize="small" sx={{ color, fontSize: '18px' }} />
                                                                </Box>
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{short.ivr_lists[langIndex]}:</strong> {s.virtual}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        
                                                        {s?.noaction || String(s.noaction) === '0' ? (() => {
                                                            const noVal = String(s.noaction)
                                                            const groupVirtuals = (data || []).map((g) => String(g.virtual))
                                                            const isGroup = groupVirtuals.includes(noVal)
                                                            const isFunctionCode = shortFunctionList[noVal]?.length
                                                            const name = isFunctionCode ? shortFunctionList[noVal][langIndex] : (data?.find((g) => String(g.virtual) === noVal)?.name || noVal)
                                                            const displayText = isFunctionCode ? name : noVal
                                                            return (
                                                                <Box
                                                                    sx={{
                                                                        ...activitiesStyles.metadataItem,
                                                                        flexWrap: 'wrap',
                                                                        gap: 0.75,
                                                                    }}
                                                                >
                                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <Box sx={{ ...activitiesStyles.iconSquareBox, position: 'relative' }}>
                                                                            <DialpadIcon fontSize="small" sx={{ color, fontSize: 16 }} />
                                                                            <Box
                                                                                sx={{
                                                                                    position: 'absolute',
                                                                                    top: '50%',
                                                                                    left: '50%',
                                                                                    width: '130%',
                                                                                    height: 2,
                                                                                    backgroundColor: '#d32f2f',
                                                                                    transform: 'translate(-50%, -50%) rotate(45deg)',
                                                                                    pointerEvents: 'none',
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                        <Typography component="span" variant="caption" sx={{ ...activitiesStyles.metadataText, fontWeight: 600 }}>
                                                                            {ivrSingle.no_answer_list[langIndex]}:
                                                                        </Typography>
                                                                    </Box>
                                                                    <Tooltip title={name} placement="top">
                                                                        <Box
                                                                            component="span"
                                                                            sx={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: 0.5,
                                                                                px: 1,
                                                                                py: 0.25,
                                                                                borderRadius: 1,
                                                                                backgroundColor: 'action.hover',
                                                                                border: '1px solid',
                                                                                borderColor: 'divider',
                                                                                fontSize: '0.8rem',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            {isFunctionCode ? (
                                                                                noVal === '59999' || noVal === '100097' ? <VoicemailIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} /> : noVal === '10888' ? <CallEndIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} /> : <PhoneIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            ) : isGroup ? (
                                                                                <GraphicEqIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            ) : (
                                                                                <GroupIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            )}
                                                                            <Typography component="span" variant="caption" sx={activitiesStyles.metadataText}>
                                                                                {displayText}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Tooltip>
                                                                </Box>
                                                            )
                                                        })() : null}
                                                        {(s?.item?.length || s?.item_count) ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <ListIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{short.list[langIndex]}:</strong> {s?.item?.length || s?.item_count || 0}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                    </Box>
                                                </Box>

                                                <Box sx={employeeTableStyles.actionsContainer}>
                                                   
                                                    <Box sx={employeeTableStyles.actionButtonsBox}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => onEdit(s.id)}
                                                            sx={{
                                                                color,
                                                                '&:hover': { backgroundColor: `${color}15`, transform: 'scale(1.1)' },
                                                                transition: 'all 0.2s ease',
                                                                padding: '6px',
                                                            }}
                                                            aria-label={ivr.edit_action[langIndex]}
                                                        >
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </IconButton>
                                                        {employeeData?.buddy? null :<IconButton
                                                            size="small"
                                                            onClick={() => onDelete(s.id)}
                                                            sx={{ ...employeeTableStyles.deleteIconButton }}
                                                            aria-label={ivr.delete_action[langIndex]}
                                                        >
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </IconButton>}
                                                    </Box>
                                                    
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                )
                            })}
                        </Box>
                        <Box sx={employeeTableStyles.footerBox}>
                            <Box className="footer-chip-box" sx={{
                                ...employeeTableStyles.footerLinksBox,
                                '& .MuiChip-root': { borderColor: color },
                                '& .MuiChip-root:hover': { backgroundColor: `${color} !important`, color: '#fff !important', borderColor: `${color} !important` },
                                '& .MuiChip-root:hover .MuiChip-label': { color: '#fff !important' },
                            }}>
                                <Chip label={ivr.excel[langIndex]} variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 14, '& .MuiChip-label': { fontSize: 14 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label={ivr.csv[langIndex]} variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 14, '& .MuiChip-label': { fontSize: 14 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label={ivr.print[langIndex]} variant="outlined" size="small" onClick={() => window.print()} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 14, '& .MuiChip-label': { fontSize: 14 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label={ivr.copy[langIndex]} variant="outlined" size="small" onClick={() => Utils.copy(setCopied)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 14, '& .MuiChip-label': { fontSize: 14 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                            </Box>
                            <TablePagination
                                rowsPerPageOptions={[10, 18, 27, 36, { label: ivr.all[langIndex], value: -1 }]}
                                component="div"
                                count={sortedData.length}
                                labelRowsPerPage={input.rowsPerPage[langIndex]}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Box>
                    </>
                ) : (
                    <Box sx={employeeTableStyles.emptyStateBox}>
                        <Typography variant="body1" color="text.secondary">
                            {ivrSingle.no_found[langIndex]}
                        </Typography>
                    </Box>
                )}
            </Paper>
            {copied ? <div className="copied">{ivr.copied[langIndex]}</div> : null}
        </div>
    )
}
